import { runInAction } from 'mobx';
import { getCurrentMemberSubscription } from '../../../selectors/member/subscriptions/get-current-member-subscription';
export const clearCurrentMemberSubscriptionBillingError = () => {
    const memberSubscription = getCurrentMemberSubscription();
    if (!memberSubscription)
        return;
    runInAction(() => {
        memberSubscription.billingDetails.billingError = undefined;
        memberSubscription.billingDetails.isUsingThirdPartyPaymentProvider = false;
    });
};
